/**
 * Browser entry point for the refundability rule. Re-exports the canonical
 * `isFullyRefundableOption` from `src/utils/index.ts` under the same name our
 * change-flight code paths use (`isRefundableFareBrand`) so the predicate
 * matches everywhere — the search-time DZ filter in `src/pages/FlightOptions.jsx`
 * uses `isFullyRefundableOption` directly, and the change-flight Edge Functions
 * + Express server use hand-mirrored ports in:
 *   - supabase/functions/_shared/fare-brand-refundability.ts
 *   - server/fare-brand-refundability.js
 *
 * If you need to change the refundability rule, update src/utils/index.ts and
 * mirror the change into the two server-side ports.
 */
import { isFullyRefundableOption } from '@/utils';

export const isRefundableFareBrand = isFullyRefundableOption;

export function changeFlightNeedsRefundableTarget(paymentMethod) {
  return paymentMethod === 'defera_zero';
}

export const NON_REFUNDABLE_CHANGE_BLOCKED_MESSAGE =
  'Defera Zero requires a refundable fare. Please pick a fully refundable fare brand ' +
  '(e.g. American Main Select, Southwest Anytime / Business Select, or any fare marked ' +
  'Refundable / Flex) — Basic / Wanna Get Away / Bare Fare cannot be carried on Defera Zero.';
